// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2ad20123] .mirador-thumbnail-nav-canvas:focus{outline:2px solid #0a72cc !important}[data-v-2ad20123] .mirador-thumb-navigation{height:100px !important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
